// Browser-side reader for THE disease colour palette.
//
// This imports the SAME JSON the server allocator reads
// (backend/util/disease-palette.json), so there is one definition rather than a
// mirror that drifts. Vite inlines the JSON at build time, so nothing at runtime
// reaches outside the bundle and the backend is not a runtime dependency of the
// app. The JSON's own header explains why the order and the mixed casing are
// load-bearing — do not re-case or reorder either side.
//
// Before TGCLOUD-1793 there were three copies: this palette existed once in
// backend/util/util.js, again in pedigree-tool/pedigree/fetusDiagnoses.js, and a
// THIRD time in ColorPicker.jsx with only 18 of the 20 colours and an extra
// #000000 the server never allocates.

import paletteFile from '../../backend/util/disease-palette.json';

/** The palette as `{ hex, name }`. `name` drives picker aria-labels. */
export const DISEASE_PALETTE = Object.freeze(
  paletteFile.palette.map((entry) => Object.freeze({ ...entry }))
);

/** Hex-only view, in allocation order — the shape the allocator walks. */
export const FIXED_DIAGNOSES_COLORS = Object.freeze(
  DISEASE_PALETTE.map((entry) => entry.hex)
);
